import { render, staticRenderFns } from "./ReplaceImage.vue?vue&type=template&id=650a88d4&scoped=true&"
import script from "./ReplaceImage.vue?vue&type=script&lang=js&"
export * from "./ReplaceImage.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceImage.vue?vue&type=style&index=0&id=650a88d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a88d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VCard,VImg,VOverlay})
